<!-- 顶部导航 -->
<template>
<div class="header">
    <p>欢迎来到游戏角网络官网！</p>
    <div class="header_layout">
        <div class="header_left">
            <img src="https://cdn.welove520.com/static/res/vue/playbay/playbay_logo.png">
            <span>发现角游戏 | 一起游戏更甜蜜</span>
        </div>
        <div class="header_router">
            <router-link to="/home">首页</router-link>
            <!-- <router-link to="/game">游戏</router-link> -->
            <router-link to="/parents">家长监护</router-link>
            <router-link to="/about">关于我们</router-link>
        </div>

        <div class="header_right">
            <router-link to="/login">
              <img src="https://cdn.welove520.com/static/res/vue/playbay/login_icon.png">
              <span>登录</span>
            </router-link>
            <router-link to="/register">
              <img src="https://cdn.welove520.com/static/res/vue/playbay/register_icon.png">
              <span>注册</span>
            </router-link>
            <router-link to="/recharge">
              <img src="https://cdn.welove520.com/static/res/vue/playbay/recharge_icon.png">
              <span>充值中心</span>
            </router-link>
        </div>
    </div>
    <div v-if="$store.state.currentTab === 'home'"></div>
    <div v-else class="header_bottom">
      <div class="subtab" v-if="$store.state.currentTab === 'parents'">
        <router-link to="/parents/guard">家长监护</router-link>
        <router-link to="/parents/service">服务申请</router-link>
      </div>

      <div class="subtab" v-else-if="$store.state.currentTab === 'about'">
        <router-link to="/about/introduce">公司介绍</router-link>
        <router-link to="/about/team">团队活动</router-link>
        <router-link to="/about/contact">联系我们</router-link>
      </div>
    </div>
</div>

</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
.header {
  display: flex;
  flex-flow: column nowrap;
}

.header > p {
  font-size: 10px;
  color: #88898e;
  background: #f2f2f2;
  width: 100%;
  height: 40px;
  padding-left: 15%;
  padding-top: 10px;
}

.header_layout {
  width: 100%;
  height: 70px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
}

.header_left {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-left: 60px;
  width: 320px;
}

.header_left > img {
  width: 100px;
  height: 45px;
}

.header_left > span {
  font-size: 14px;
  color: #dc4f6b;
  margin-left: 20px;
}

.header_router {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}

.header_router > a {
  font-size: 18px;
  color: #303032;
  margin: 0 20px;
}

a:-webkit-any-link {
  color: #303032;
  text-decoration: none;
}

/*底部router-link 的激活样式切换*/
.header_router > .router-link-active {
  border-bottom: 4px solid #f95072;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}

.header_right {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  margin-right: 60px;
  width: 300px;
}

.header_right > a {
  font-size: 14px;
  color: #303032;
  margin: 0 10px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.header_right > a > img {
  width: 15px;
  height: 15px;
}

.header_bottom {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  background-color: #f95072;
  width: 100%;
  height: 50px;
  padding-left: 60px;
  padding-top: 5px;
}

.subtab > a {
  font-size: 18px;
  color: white;
  padding: 10px 20px;
  width: 115px;
  height: 45px;
  display: inline-block;
}

.subtab > .router-link-active {
  color: #e1556d;
  background: white;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue